import MicroModal from 'micromodal';
import { load } from '@shopify/theme-sections';
import events from '../utils/events';
import ScrollTo from '../components/scroll-to-reviews';

import '../components/template-product';

load('*');

MicroModal.init({
    awaitCloseAnimation: true,
    awaitOpenAnimation: true,
    disableScroll: true,
    openClass: 'modal--active',
});

const selectors = {
    yotpoToggle: '[data-yotpo-toggle]',
    scrollTarget: '[data-yotpo-reviews]'
};

// Scope to the product form: it wraps both the rating (click target, rendered
// before .product-details) and the reviews accordion (scroll target, inside
// .product-details). Scoping to .product-details misses the click target, so
// the listener never attaches and clicking the stars does nothing.
const productForm = document.querySelector('[data-product-form]');

if (productForm) {
    new ScrollTo(
        productForm,
        selectors.scrollTarget,
        selectors.yotpoToggle,
        events.accordionOpen
    );
}